// Safe JSON parse helper
export const safeJsonParse = (jsonString, defaultValue = []) => {
  if (!jsonString) return defaultValue

  // If already an array/object, return it
  if (typeof jsonString === 'object') return jsonString

  // If it's a string, try to parse it
  try {
    return JSON.parse(jsonString)
  } catch (error) {
    console.error('JSON parse error:', error)
    return defaultValue
  }
}

// Get first image from tour
export const getTourImage = (tour, index = 0) => {
  const images = safeJsonParse(tour.images, [])
  return images[index] || 'https://placehold.co/400x300?text=No+Image'
}

// Get service image or image_url
export const getServiceImage = (service) => {
  // If service has image_url, use it
  if (service.image_url) return service.image_url

  // Otherwise try to parse images array
  const images = safeJsonParse(service.images, [])
  return images[0] || 'https://placehold.co/400x300?text=No+Image'
}

// Format price
export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(price)
}

// Format currency (alias for formatPrice)
export const formatCurrency = formatPrice

// Format date
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
